package com.klantenstop.web.data.models.dto.requests.company

import com.klantenstop.web.data.models.dto.requests.address.UpdateAddress
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UpdateCompany(
    val name: String? = null,
    val description: String? = null,
    val categories: List<String>? = null,
    val address: UpdateAddress? = null,
    val verified: Boolean? = null,
    @SerialName("phone_number")
    val phoneNumber: String? = null,
    @SerialName("email_address")
    val emailAddress: String? = null,
    val website: String? = null
)
